import { Navigate } from 'react-router-dom';
import BusinessTable from '../scenes/businessTable';
import Contacts from '../scenes/contacts';
import CreateUser from '../scenes/createUser';
import CustomerList from '../scenes/customers';
import CustomerForm from '../scenes/customers/form';
import Dashboard from '../scenes/dashboard';
import DashboardSuperAdmin from '../scenes/dashboardSuperAdmin';
import Form from '../scenes/form';
import {
  FormSuccessBussines,
  FormSuccessClient,
  FormSuccessUpdateProposalStatus,
} from '../scenes/form/success';
import Profile from '../scenes/profile';
import { ProposalsUser } from '../scenes/proposalUser';
import { Proposals } from '../scenes/proposals';
import Red25 from '../scenes/red25';
import Red25Sem from '../scenes/red25sem';
import Red25Tri from '../scenes/red25tri';
import RedCoins from '../scenes/redCoins';
import Payments from '../scenes/redCoins/Payments';
import ConsultList from '../scenes/redCoins/consultList';
import Redrural from '../scenes/redrural';
import RedScore from '../scenes/redscore';
import RegisterCustomer from '../scenes/registerCustomerForm';
import Team from '../scenes/team';
import HelpPage from '../scenes/termsScreen/faq';
import FinancialSimulation from '../scenes/financialSimulation';
import SimulatorSuperAdmin from '../scenes/simulatorSuperAdmin';
import Resale from '../scenes/resaleSuperAdmin';
import ResaleDetails from '../scenes/resaleSuperAdmin/resaleDetails';
import SimulationSuperAdmin from '../scenes/simulation';
import SimulationDetailSuperAdmin from '../scenes/simulation/detail';
import ResaleSettings from '../scenes/resaleSuperAdmin/resaleSettings';
import RedScoreSuperAdmin from '../scenes/redscoreSuperAdmin';
import Contratos from '../scenes/contracts';
import ContractFormPage from '../scenes/contracts/ContractFormPage';

export const allRoutes = {
  home: {
    path: 'dashboard',
    element: <Dashboard />,
  },
  // homeUser: {
  //   path: "",
  //   element: <DashboardUser/>,
  // },
  homeSuperAdmin: {
    path: 'dashboard',
    element: <DashboardSuperAdmin />,
  },
  team: {
    path: 'team',
    element: <Team />,
  },
  contacts: {
    path: 'contacts',
    element: <Contacts />,
  },
  form: {
    path: 'form',
    element: <Form />,
  },
  formSucessBussines: {
    path: 'successbussines',
    element: <FormSuccessBussines />,
  },
  formSucessClient: {
    path: 'successclient',
    element: <FormSuccessClient />,
  },
  formSucessStatus: {
    path: 'successstatus',
    element: <FormSuccessUpdateProposalStatus />,
  },
  red25: {
    path: 'red25',
    element: <Red25 />,
  },
  redtri: {
    path: 'red25tri',
    element: <Red25Tri />,
  },
  redrural: {
    path: 'redrural',
    element: <Redrural />,
  },
  redsafra: {
    path: 'red25sem',
    element: <Red25Sem />,
  },
  redscore: {
    path: 'redscore',
    element: <RedScore />,
  },
  proposal: {
    path: 'proposals',
    element: <Proposals />,
  },
  proposalUser: {
    path: 'proposals/user',
    element: <ProposalsUser />,
  },
  profile: {
    path: 'profile',
    element: <Profile />,
  },
  customers: {
    path: 'customers',
    element: <CustomerList />,
  },
  customerFormCreate: {
    path: 'customers/new',
    element: <CustomerForm />,
  },
  customerFormEdit: {
    path: 'customers/:id/edit',
    element: <CustomerForm isEditing />,
  },
  createUser: {
    path: 'createUser',
    element: <CreateUser />,
  },
  clientTable: {
    path: '',
    element: <Navigate to="/app/customers" replace />,
  },
  businessTable: {
    path: 'business',
    element: <BusinessTable />,
  },
  redCoins: {
    path: 'redutoconsultas',
    element: <RedCoins />,
  },
  redConsultsList: {
    path: 'consultas/redscore',
    element: <ConsultList />,
  },
  createUserWithoutConsult: {
    path: 'users/create',
    element: <RegisterCustomer />,
  },
  payments: {
    path: 'payments',
    element: <Payments />,
  },
  simulation: {
    path: 'simulation',
    element: <FinancialSimulation />,
  },
  simulationEdit: {
    path: 'simulation/:id',
    element: <FinancialSimulation />,
  },
  simulatorSuperAdmin: {
    path: 'simulators',
    element: <SimulatorSuperAdmin />,
  },
  resale: {
    path: 'resale',
    element: <Resale />,
  },
  resaleDetails: {
    path: 'resale/:id',
    element: <ResaleDetails />,
  },
  resaleSettings: {
    path: 'resale/:id/settings',
    element: <ResaleSettings />,
  },
  simulationSuperAdmin: {
    path: 'simulation-adm',
    element: <SimulationSuperAdmin />,
  },
  simulationSuperAdminDetail: {
    path: 'simulation-adm/:id',
    element: <SimulationDetailSuperAdmin />,
  },
  redscoreSuperAdmin: {
    path: 'redscore-adm',
    element: <RedScoreSuperAdmin />,
  },
  contratos: {
    path: 'contratos',
    element: <Contratos />,
  },
  contratosNew: {
    path: 'contratos/new',
    element: <ContractFormPage />,
  },
  contratosEdit: {
    path: 'contratos/:id/edit',
    element: <ContractFormPage isEditing />,
  },

  // rota de erro ao pagar
};
